



































import {Component, Vue} from "vue-property-decorator";


export default class Problem extends Vue {

    private showKey: string = "";

    private problemList: Array<{ ask: string, answer: string, isShow: string }> = [
        {
            ask: "How can I get Nsure tokens?",
            isShow: "1",
            answer: "The main options to get NSURE tokens now is either through our upcoming Balancer Liquidity Bootstrapping Pool (LBP), or capital mining post-TGE.",
        },
        {
            ask: "When will the TGE take place on Balancer LBP?",
            isShow: "2",

            answer: "The TGE via LBP on Balance will take place on the October 28th starting at 11:00am UTC, for a duration of approximately 2 days, from block 11144773 to block 11157773."
        },

        {
            ask: "Why can’t I purchase the tokens from Balancer LBP at the 1st block?",
            isShow: "4",
            answer: "Participants should not purchase NSURE tokens when LBP starts, there will be a very large slippage to be dealt with."
        },
        {
            ask: "What is the best strategy to get NSURE from LBP?",
            isShow: "5",
            answer: "If you want to submit a very large order, the best strategy for you is to divide the order into small chunks and spread them out over 2 days to average down the price."
        },
        {
            ask: "Can I use tokens other than USDC to get NSURE from LBP?",
            isShow: "6",
            answer: "Yes, any token supported on Balancer can be used to exchange for our token (but usually, the exchange rate will be worse due to multiple hops between different pools on Balancer)."
        },
        {
            ask: "Can I get NSURE from Uniswap?",
            isShow: "7",
            answer: "It’s possible that during the two-day existence of the Balancer’s Liquidity Bootstrapping Pool (LBP), someone who has acquired our token and created a pool for people to buy it. But we expect there will be lots of scam pools on Uniswap. Therefore, it’s recommended only to get NSURE from our LBP on Balancer."
        },
        {
            ask: "Which Wallet is supported on Balancer LBP?",
            isShow: "8",
            answer: "Metamask, Portis, or any wallet that can be connected to a desktop Dapp through wallet connect should be fine. You can test if your wallet is supported now by going to Balancer’s website and swapping a token to another. https://balancer.exchange"
        },
        {
            ask: "What happens to the proceeds after LBP concludes?",
            isShow: "9",
            answer: "Once the LBP has come to an end, 10% of the funds raised will be utilised for seeding a pool of selected AMMs for trading purposes. For the resulting amount of NSURE unsold after the LBP, it will be partially utilised for liquidity purposes, as well as for initially providing capacity on insurance products once the Nsure Network goes live. After the platform naturally grows in capacity, and the boost is no longer needed, the tokens will be transferred to the Nsure DAO to decide on it’s management."
        },


    ];

    private economicsList: Array<{ one: string, tow: string }> = [

        {
            one: " LBP Allocation",
            tow: "  4,000,000 NSURE"
        },
        {
            one: "Total Token Supply",
            tow: "  100,000,000 NSURE"
        },
        {
            one: "Initial Circulating Supply",
            tow: "  9% of Total Token Supply"
        },
        {
            one: "LBP Token Price Ceiling",
            tow: "  5 USDC"
        },
        {
            one: "LBP Token Price Floor",
            tow: "  0.10 USDC"
        },
        {
            one: "Airdrop Allocation",
            tow: "100,000 NSURE"
        },
        {
            one: "LBP Vesting Period",
            tow: "No lockup"
        },
        {
            one: "Private Sale Token Price",
            tow: "1 NSURE = 0.10 USD"
        },
        {
            one: "Private Sale Allocation",
            tow: "14% of Total Token Supply"
        },
        {
            one: "Private Sale Vesting Period",
            tow: "20% unlocked, 20% release every 3 months (>1 year total vesting period)."
        },
        {
            one: "Seed Token Price",
            tow: "1 NSURE = 0.05 USD"
        },
        {
            one: "Seed Allocation",
            tow: "1% of Total Token Supply"
        },

        {
            one: "Foundation Reserve Allocation",
            tow: "10% of Total Token Supply",
            msg:'*1'
        },
        {
            one: "Marketing & Operations Allocation",
            tow: "10% of Total Token Supply "
        },
        {
            one: "Marketing & Operations Vesting Period",
            tow: "20%unlocked. 20% release every 6 months over 2 years."
        },
        {
            one: "Team Allocation",
            tow: "6% of Total Token Supply"
        },
        {
            one: "Team Vesting Period",
            tow: "6 Month fully locked, 25% release every 6 months (>2 year total vesting period)"
        },
        {
            one: "Token Type",
            tow: "ERC20"
        },
        {
            one: "Token Distribution(Airdrop, Private sale)",
            tow: "Within 3 days after LBP concluded"
        },
    ];


    mounted(): void {
    }

    showAnswer(ev) {
        if(this.showKey == ev){
            this.showKey = '0';
        }else{
            this.showKey = ev;

        }
        this.$forceUpdate();
    }

}
